/*
 * Copyright (c) SEQTA Software 2018.
 *
 * Created by simon on 2018-06-19
 */

import React, {Component} from 'react';
import './NotFound.css';

class NotFound extends Component {
	render() {
		return (
			<div className="NotFound">
				{this.props.children || '😞 The requested resource could not be found 😞'}
			</div>
		);
	}
}

export default NotFound;


// WEBPACK FOOTER //
// ./src/widgets/NotFound.js